export const schoolInvitationRoutes = [
  {
    path: "/schoolinvitation",
    component: () => import("@/views/SchoolInvitation/List.vue"),
  },
  {
    path: "/schoolinvitation/create",
    component: () => import("@/views/SchoolInvitation/Create.vue"),
  },
  {
    path: "/schoolinvitation/multiplecreate",
    component: () => import("@/views/SchoolInvitation/MultipleCreate.vue"),
  },
  {
    path: "/schoolinvitation/update/:id",
    component: () => import("@/views/SchoolInvitation/Create.vue"),
  },
];
